import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import { enableMapSet } from 'immer';
import mapboxgl from 'mapbox-gl';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

// Esta funcion habilita usar Map y Set en el estado de los Stores de Redux
enableMapSet()

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN!;

if (process.env.REACT_APP_CURRENT_ENV === 'prod') {
  disableReactDevTools();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
